import { Box, Typography } from '@mui/material';

type SeverityItem = {
  name: string;
  amount: number;
  color: string;
  textColor: string;
  backgroundColor: string;
};

export type SeverityDataProps = {
  items: SeverityItem[];
  layout?: 'row' | 'column';
};

export const SeverityData = ({ items = [], layout = 'column' }: SeverityDataProps) => {
  const total = items.reduce((prev, curr) => prev + curr.amount, 0);

  const rows = items.map(({ name, amount, color, textColor, backgroundColor }) => ({
    name,
    amount,
    percentage: total === 0 ? 0 : (amount / total) * 100,
    color: textColor,
    borderColor: color,
    backgroundColor,
  }));

  return (
    <Box sx={{ width: 1 }}>
      {rows.map(({ name, amount, percentage, borderColor, backgroundColor }, idx) => (
        <Box key={idx} sx={{ mb: 1, overflow: 'hidden' }}>
          <Box sx={{ display: 'inline-block', float: 'left' }}>
            <Typography sx={layout === 'row' ? { display: 'inline', pr: 2, pt: 0.5 } : {}}>{name}</Typography>
            <Typography sx={{ color: 'text.secondary', ...(layout === 'row' ? { display: 'inline', pt: 0.5 } : {}) }}>
              {percentage.format({ decimals: 2 })}%
            </Typography>
          </Box>
          <Box sx={{ display: 'inline-block', float: 'right' }}>
            <Box sx={{ border: `1px solid`, borderColor, backgroundColor, borderRadius: '4px', px: 1.25, textAlign: 'center' }}>
              <Typography variant="subtitle1" component={'span'} sx={{ color: 'text.primary', lineHeight: layout === 'row' ? '1.4' : '1.75' }}>
                {amount}
              </Typography>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
